import { render, staticRenderFns } from "./LoginClient.vue?vue&type=template&id=0dd1439c&scoped=true"
import script from "./LoginClient.vue?vue&type=script&lang=js"
export * from "./LoginClient.vue?vue&type=script&lang=js"
import style0 from "./LoginClient.vue?vue&type=style&index=0&id=0dd1439c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd1439c",
  null
  
)

export default component.exports